<template>
  <footer class="p-4 text-center">
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>